<template>
    <div class="modalDetailCalendarContainer">
        <div class="modalDetailPart1">
            <div class="headerCalendarDetail">
                <h2>Periodo Académico</h2>
            </div>
            <div v-if="calendarDetailObject">
                <p><strong>Periodo Banner:</strong> {{ calendarDetailObject.periodoBanner }}</p>
                <p><strong>Periodo:</strong> {{ calendarDetailObject.periodo }}</p>
                <p><strong>Periodo Anterior:</strong> {{ calendarDetailObject.periodoAnterior }}</p>
                <p><strong>Periodo Siguiente:</strong> {{ calendarDetailObject.periodoSiguiente }}</p>
                <p><strong>Fecha Inicio Pago:</strong> {{ calendarDetailObject.inicioPago }}</p>
                <p><strong>Fecha Inicio Periodo:</strong> {{ calendarDetailObject.inicioPeriodo }}</p>
                <p><strong>Fecha Corte:</strong> {{ calendarDetailObject.corte }}</p>
                <p><strong>Fecha Fin Pago:</strong> {{ calendarDetailObject.finPago }}</p>
                <p><strong>Fecha Fin Periodo:</strong> {{ calendarDetailObject.finPeriodo }}</p>
                <p><strong>Fecha Inicio Siguiente Periodo:</strong> {{ calendarDetailObject.inicioSiguientePeriodo }}</p>
                <p><strong>Estado:</strong> {{ calendarDetailObject.estado == '1' ? 'Activo' : 'Inactivo'}}</p>         
            </div>
            <div v-else>
                <p>No se han cargado los datos del calendario.</p>
            </div>
        </div>
        <div class="modalDetailPart2">
            <div class="headerCalendarDetail">
                <h2>Programas Académicos</h2>
                <p @click="closeCalendarEditModal">X</p>
            </div>
            <div class="table-container">
                <table class="program-table">
                    <thead>
                    <tr>
                        <th class="table-header"><strong>Programa</strong></th>
                        <th class="table-header"><strong>Código Programa</strong></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(programData, index) in programDataObject" :key="index">
                        <td class="program-column">{{ programData.programa }}</td>
                        <td>{{ programData.codPrograma }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>  
    </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'

export default{
    props:{
        IdCalendarForDetail: Number,
    },
    data(){
        return{
            idCalendarForDetail: this.IdCalendarForDetail,
            calendarDetailObject : {
                calendarId: '',
                periodoBanner: '',
                periodo: '',
                periodoAnterior: '',
                periodoSiguiente: '',
                inicioPago: '',
                inicioPeriodo: '',
                corte: '',
                finPago: '',
                finPeriodo: '',
                inicioSiguientePeriodo: '',
                estado: '',
                entrada: '',
            },
            programDataObject: {}, 
        }
    },
    methods:{
        //Método para inicializar el componente
        loadData(){
            IberoHelpers.GetCalendarForId(this.$store, this.idCalendarForDetail)
                .then(response => {
                    const data = response.data[0];
                    this.calendarDetailObject.periodoBanner = data.periodoBanner;
                    this.calendarDetailObject.periodo = data.periodo += ' ' + data.entrada;
                    this.calendarDetailObject.periodoAnterior = data.periodoAnterior;
                    this.calendarDetailObject.periodoSiguiente = data.periodoSiguiente;
                    // Formatear las fechas manualmente
                    this.calendarDetailObject.inicioPago = this.formatDate(data.fechaInicioPago);
                    this.calendarDetailObject.inicioPeriodo = this.formatDate(data.fechaInicioPeriodo);
                    this.calendarDetailObject.corte = this.formatDate(data.fechaCorte);
                    this.calendarDetailObject.finPago = this.formatDate(data.fechaFinPago);
                    this.calendarDetailObject.finPeriodo = this.formatDate(data.fechaFinPeriodo);
                    this.calendarDetailObject.inicioSiguientePeriodo = this.formatDate(data.fechaInicioSiguientePeriodo);
                    this.calendarDetailObject.estado = data.staActive ? '1' : '0';
                    this.calendarDetailObject.entrada = data.entrada;
                    console.log(this.calendarDetailObject)
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
            
            IberoHelpers.GetProgramForId(this.$store, this.idCalendarForDetail)
                .then(response => {
                    this.programDataObject = response.data.map(({programa, cod_Programa}) => ({
                        programa: programa,
                        codPrograma: cod_Programa,
                    }));
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
            
        },
        formatDate(dateString) {
            // Formatear la fecha al formato "yyyy-MM-dd"
            const date = new Date(dateString);
            const year = date.getFullYear();
            let month = (date.getMonth() + 1).toString();
            let day = date.getDate().toString();

            // Agregar un 0 al principio si el número es de un solo dígito
            if (month.length === 1) {
                month = '0' + month;
            }
            if (day.length === 1) {
                day = '0' + day;
            }

            return `${year}-${month}-${day}`;
        },
        //Método para cerrar el modal
        closeCalendarEditModal(){
            this.$emit('closeCalendarDetailModal');
        }
    },
    mounted(){
        //Método para inicializar el componente
        this.loadData();
    }
}
</script>
<style scoped>
    .modalDetailCalendarContainer{
        display: flex;
        width: 80rem;
        height: 36rem;
        background-color: #fff;
        padding: 2rem;
    }

    .modalDetailPart1{
        margin-right: 6rem;
        border-right: #d0ab4b 0.2rem solid;
        padding-right: 1rem;
    }
    .headerCalendarDetail{
        display: flex;
        justify-content: space-between;
    }
    .headerCalendarDetail h2{
        color: #d0ab4b;
        font-weight: bold;
        font-size: 1.5rem;
        margin-bottom: 2.5rem;
    }
    .headerCalendarDetail p{
        color: #d0ab4b;
        font-weight: bold;
        font-size: 1.5rem;
        cursor: pointer;
    }
    .program-table {
        width: 100%;
        border-collapse: collapse;
    }

    .table-header {
        padding-bottom: 10px;
        padding-right: 1rem;
    }

    /* Estilos para la columna del programa */
    .program-column {
        width: 35rem;
        max-width: 35rem; /* Puedes ajustar el ancho máximo según tu preferencia */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 1rem;
        padding-right: 2rem;
    }

    .table-container {
        max-height: 26rem; /* Ajusta la altura máxima según sea necesario */
        overflow-y: auto; /* Añade una barra de desplazamiento vertical si es necesario */
    }

</style>